/* eslint-disable */
import { makeAutoObservable, runInAction } from 'mobx';
import { copyLastWeekAsync } from '../../api/copyLastWeek';
import { CommunityEntity, getCommunityEntities } from '../../api/getCommunityEntities';
import { UserWeeklyLog, getUserWeeklyLog } from '../../api/getUserWeeklyLog';
import { CatWeek } from '../../api/getWeeks';
import { saveEntries } from '../../api/saveEntries';

export type UserWeeklyLogItem = {
    Key: number,
    UserWeeklyLog: UserWeeklyLog,
    isSelectError: boolean,
    isPercentLoggedError: boolean,
    isHoursLoggedError: boolean
}

class UserWeeklyLogStore {
    isLoading: boolean = false;
    CommunityList: Array<CommunityEntity> = [];
    selectedCatWeek: CatWeek = {} as CatWeek;
    UserWeeklyLogItems: Array<UserWeeklyLogItem> = [];
    NON_COMMUNITY_ID: string = "0000";
    NonCommunityWork: UserWeeklyLog;
    error: string = "";
    copyLastWeekError: string = "";
    isEditHours: boolean = false;
    isDisableEditHours: boolean = false
    isSubmitButtonDisabled: boolean = false;
    _maxHour: number = 40;

    constructor() {
        makeAutoObservable(this);
    }

    get isOutsideEditingWindow(): boolean {
        if (!this.selectedCatWeek?.lastDay) return false;
        const lastDay = new Date(this.selectedCatWeek.lastDay);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        lastDay.setHours(0, 0, 0, 0);
        return (today.getTime() - lastDay.getTime()) / (1000 * 60 * 60 * 24) > 14;
    }

    setSelectedWeek = (week: CatWeek) => {
        if (this.CommunityList.length > 0 || this.CommunityList.length == 0) {
            if (!this.isLoading) {
                this.isLoading = true;
            }
            runInAction(() => {
                getCommunityEntities().then(res => {
                    const data = res.data;
                    this.CommunityList = Array.isArray(data) ? data : [];
                }).catch(err => {
                    this.error = err
                })
            })

            if (this.isLoading) {
                this.isLoading = false;
            }
        }

        this.selectedCatWeek.firstDay = week.firstDay;
        this.selectedCatWeek.lastDay = week.lastDay;
        this.selectedCatWeek.firstDayStr = week.firstDayStr;
        this.selectedCatWeek.lastDayStr = week.lastDayStr;
        this.selectedCatWeek.id = week.id;
        this.selectedCatWeek.locked = week.locked;
        this.selectedCatWeek.monthYearId = week.monthYearId;
        this.selectedCatWeek.percentLoggedInSum = week.percentLoggedInSum;
        this.selectedCatWeek.week = week.week;

        this.getWeeklyLog(this.selectedCatWeek.id);
    }

    getWeeklyLog = (catWeekId: number) => {
        runInAction(() => {
            getUserWeeklyLog(catWeekId).then(res => {
                if (res.data != null) {
                    const newArray = res.data.filter((_: { entityId: string; }) => _.entityId != this.NON_COMMUNITY_ID).map((_: UserWeeklyLog, index: number) => {
                        const newItem = {
                            Key: index,
                            RenderCommunityList: this.CommunityList,
                            UserWeeklyLog: _,
                            isSelectError: false,
                            isPercentLoggedError: false,
                            isHoursLoggedError: false
                        }
                        return newItem;
                    })

                    const arrayIsEditHours = res.data.filter((_: { entityId: string; isHoursEdit:boolean }) => _.entityId != this.NON_COMMUNITY_ID && _.isHoursEdit === true)
                    if(arrayIsEditHours.length > 0){
                        this.isEditHours = true
                        this.isDisableEditHours = true
                    }else{
                        this.isEditHours = false
                        this.isDisableEditHours = false
                    }

                    let NON_COMMUNITY = res.data.filter((_: { entityId: string; }) => _.entityId == this.NON_COMMUNITY_ID);
                    if (NON_COMMUNITY[0]) {
                        this.NonCommunityWork = NON_COMMUNITY[0];
                    }
                    else {
                        const newUserWeeklyLog = {
                            weeklyLogId: 0,
                            weekYearId: this.selectedCatWeek.id,
                            entityId: this.NON_COMMUNITY_ID,
                            percentLogged: 0,
                            dateTime: new Date(),
                            jobCode: '',
                            jobDescription: '',
                            officeLocation: '',
                            orgLevel2: 0,
                            orgLevel4: 0,
                            hoursLogged: 0,
                            adlogon: '',
                            isDeleted: false,
                            isHoursEdit: false
                        }
                        this.NonCommunityWork = newUserWeeklyLog;
                    }

                    this.UserWeeklyLogItems = newArray;
                }
                else {
                    this.UserWeeklyLogItems = []
                }

                if (this.isLoading) {
                    this.isLoading = false;
                }
            }).catch(err => {
                this.error = err
                if (this.isLoading) {
                    this.isLoading = false;
                }
            })
        })
    }

    copyLastWeek = () => {
        this.copyLastWeekError = "";
        runInAction(() => {
            copyLastWeekAsync().then(res => {
                if (res.data != null) {
                    const newArray = res.data.filter((_: { entityId: string; }) => _.entityId != this.NON_COMMUNITY_ID).map((_: UserWeeklyLog, index: number) => {
                        const newItem = {
                            Key: this.UserWeeklyLogItems.length > 0 ? this.UserWeeklyLogItems[this.UserWeeklyLogItems.length - 1].Key + 1 + index : index,
                            RenderCommunityList: this.CommunityList,
                            UserWeeklyLog: _,
                            isSelectError: false,
                            isPercentLoggedError: false,
                            isHoursLoggedError: false
                        }
                        return newItem;
                    })
                    this.UserWeeklyLogItems = [...this.UserWeeklyLogItems, ...newArray];

                    if(this.isEditHours)
                    {
                        let NON_COMMUNITY = res.data.filter((_: { entityId: string; }) => _.entityId == this.NON_COMMUNITY_ID);
                        if (NON_COMMUNITY[0]) {
                            let hours = this.NonCommunityWork.hoursLogged + NON_COMMUNITY[0].hoursLogged;
                            console.log(hours);
                            this.NonCommunityWork = {...this.NonCommunityWork, hoursLogged: hours}
                        }
                    }

                    this.recalculatePercentage();
                }
                else {
                    this.copyLastWeekError = "Last week is empty";
                }

                if (this.isLoading) {
                    this.isLoading = false;
                }
            }).catch(err => {
                this.error = err
                if (this.isLoading) {
                    this.isLoading = false;
                }
            })
        })
    }

    addUserWeeklyLogItem = () => {
        const newUserWeeklyLog = {
            weeklyLogId: 0,
            weekYearId: this.selectedCatWeek.id,
            entityId: "0",
            percentLogged: 0,
            dateTime: new Date(),
            jobCode: '',
            jobDescription: '',
            officeLocation: '',
            orgLevel2: 0,
            orgLevel4: 0,
            hoursLogged: 0,
            adlogon: '',
            isDeleted: false,
            isHoursEdit: this.isEditHours
        }

        const newItem = {
            Key: this.UserWeeklyLogItems.length > 0 ? this.UserWeeklyLogItems[this.UserWeeklyLogItems.length - 1].Key + 1 : 1,
            UserWeeklyLog: newUserWeeklyLog,
            isSelectError: false,
            isPercentLoggedError: false,
            isHoursLoggedError: false
        }

        this.UserWeeklyLogItems = [...this.UserWeeklyLogItems, newItem]
    }

    deleteSearchCommunityInput = (key: number) => {
        const item = this.UserWeeklyLogItems.filter(_ => _.Key == key)
        if (item.length > 0) {
            if (item[0].UserWeeklyLog.weeklyLogId > 0) {
                this.UserWeeklyLogItems = this.UserWeeklyLogItems.map((item) => (item.Key === key ? { ...item, UserWeeklyLog: { ...item.UserWeeklyLog, isDeleted: true } } : item));
            }
            else {
                this.UserWeeklyLogItems = this.UserWeeklyLogItems.filter(_ => _.Key != key);
            }

            this.recalculatePercentage();
        }
    }

    changeTimeAllocatorPercent = (str: string = "", key: number) => {
        let present = 100;

        if (this.UserWeeklyLogItems.length > 0) {
            this.UserWeeklyLogItems.forEach(_ => _.Key != key ? present -= _.UserWeeklyLog.percentLogged : present -= 0)
        }
        const reg = /^[+-]?\d+(\.\d+)?$/;
        if (reg.test(str) || str === '') {
            const newNumber = parseFloat(str == "" ? "0" : parseFloat(str).toFixed(1));
            const item = this.UserWeeklyLogItems.filter(_ => _.Key == key)
            if (item.length > 0) {
                const newArray = this.UserWeeklyLogItems.map(_ => {
                    if (_.Key == key) {
                        _.UserWeeklyLog.percentLogged = newNumber;
                        _.isPercentLoggedError = false;
                        const hours = newNumber * this._maxHour / 100;
                        _.UserWeeklyLog.hoursLogged = parseFloat(hours.toFixed(1));
                    }
                    return _;
                })
                this.UserWeeklyLogItems = newArray;
            }
        }
        this.getTotalNonCommunityTimeAllocator();
    }

    changeCommunityFromSelect = (entityId: string, key: number) => {
        const item = this.UserWeeklyLogItems.filter(_ => _.Key == key)
        if (item.length > 0) {
            const newArray = this.UserWeeklyLogItems.map(_ => {
                if (_.Key == key) {
                    _.UserWeeklyLog.entityId = entityId;
                    _.isSelectError = false;
                }
                return _;
            })
            this.UserWeeklyLogItems = newArray;
        }
    }

    changeTimeAllocatorHRS = (str: string = "", key: number) => {
        const reg = /^[+-]?\d+(\.\d+)?$/;
        if (reg.test(str) || str === '') {
            const newNumber = parseFloat(str == "" ? "0" : parseFloat(str).toFixed(1));
            const item = this.UserWeeklyLogItems.filter(_ => _.Key == key)
            if (item.length > 0) {
                const newArray = this.UserWeeklyLogItems.map(_ => {
                    if (_.Key == key) {
                        _.UserWeeklyLog.hoursLogged = newNumber
                        _.isHoursLoggedError = false;
                    }
                    return _;
                })
                this.UserWeeklyLogItems = newArray;
                this.recalculatePercentage();
            }
        }
    }

    saveEntries = async () => {
        if (!this.isLoading) {
            this.isLoading = true;
        }

        this.validateArray();

        if (this.UserWeeklyLogItems.some((log) => log.isHoursLoggedError || log.isPercentLoggedError || log.isSelectError)) {
            if (this.isLoading) {
                this.isLoading = false;
            }
            return false;
        }

        const items = this.UserWeeklyLogItems.map(_ => {
            _.UserWeeklyLog.weekYearId = this.selectedCatWeek.id;
            return _.UserWeeklyLog
        })

        items.push(this.NonCommunityWork);

        try {
            var res = await saveEntries(items);
            if (res.status) {
                return true;
            }
            return false;
        } finally {
            if (this.isLoading) {
                this.isLoading = false;
            }
        }
    }

    setIsEditHours = (checked: boolean) => {
        this.isEditHours = checked;
        if(checked){
            this.isDisableEditHours = true
        }
        this.setIsSubmitButtonDisabled(false);
        this.recalculatePercentage();
        this.UserWeeklyLogItems = this.UserWeeklyLogItems.map(_ => {
            _.UserWeeklyLog.isHoursEdit = checked;
            return _
        })
    }

    setIsSubmitButtonDisabled = (disabled: boolean) => {
        this.isSubmitButtonDisabled = disabled;
    }

    recalculatePercentage = () => {
        if (this.isEditHours) {
            let total = 0;
            this.UserWeeklyLogItems.forEach(_ => {
                if (!_.UserWeeklyLog.isDeleted) {
                    total += _.UserWeeklyLog.hoursLogged;
                }
            })

            total += this.NonCommunityWork.hoursLogged;

            const newArray = this.UserWeeklyLogItems.map(_ => {
                if (!_.UserWeeklyLog.isDeleted) {
                    let percent = _.UserWeeklyLog.hoursLogged * 100 / total;
                    if ((percent >= 0) == false) {
                        percent = 0;
                    }
                    _.UserWeeklyLog.percentLogged = this.toFixed(percent,1);
                }
                return _;
            })
            this.UserWeeklyLogItems = newArray;

            let communityTotalPercent = 0;
            this.UserWeeklyLogItems.forEach(_ => {
                if (!_.UserWeeklyLog.isDeleted) {
                    communityTotalPercent += _.UserWeeklyLog.percentLogged;
                }
            })
            const percentNonCommunityWork = this.toFixed(100 - communityTotalPercent, 1);
            this.NonCommunityWork = {... this.NonCommunityWork, percentLogged : percentNonCommunityWork};
        }
        else {
            const newArray = this.UserWeeklyLogItems.map(_ => {
                if (!_.UserWeeklyLog.isDeleted) {
                    const hours = _.UserWeeklyLog.percentLogged * this._maxHour / 100;
                    _.UserWeeklyLog.hoursLogged = parseFloat(hours.toFixed(1));
                }

                return _;
            })

            this.UserWeeklyLogItems = newArray;
            this.getTotalNonCommunityTimeAllocator();
        }

    }

    validateArray() {
        const newArray = this.UserWeeklyLogItems.map(_ => {
            if (!_.UserWeeklyLog.isDeleted) {
                _.isSelectError = _.UserWeeklyLog.entityId == "0";
                _.isPercentLoggedError = _.UserWeeklyLog.percentLogged == 0;
                _.isHoursLoggedError = _.UserWeeklyLog.hoursLogged == 0;
            }

            return _;
        })
        this.UserWeeklyLogItems = newArray;
    }

    getTotalNonCommunityTimeAllocator = () => {
        let total = 100;
        this.UserWeeklyLogItems.forEach(_ => {
            if (!_.UserWeeklyLog.isDeleted) {
                total -= _.UserWeeklyLog.percentLogged
            }
        })

        total = parseFloat(total.toFixed(1))

        if (total >= 0) {
            let hoursNonCommunityWork = total * this._maxHour / 100;

            this.NonCommunityWork = {... this.NonCommunityWork, percentLogged : total, hoursLogged : parseFloat(hoursNonCommunityWork.toFixed(1))};
            this.setIsSubmitButtonDisabled(false);
        }
        else {
            this.NonCommunityWork = {... this.NonCommunityWork, percentLogged : 0, hoursLogged : 0};
            this.setIsSubmitButtonDisabled(!this.isEditHours);
        }
    }

    getTotaHRS = () => {
        if (this.isEditHours) {
            return 0;
        }

        let total = 40;
        this.UserWeeklyLogItems.forEach(_ => {
            if (!_.UserWeeklyLog.isDeleted) {
                total -= _.UserWeeklyLog.hoursLogged
            }
        })

        if(this.NonCommunityWork?.hoursLogged)
            total -= this.NonCommunityWork.hoursLogged;

        total = Math.floor(total * 100) / 100;
        total = parseFloat(total.toFixed(1));

        if (total > 0) {
            return total;
        }
        else {
            return 0;
        }
    }

    getTotalTimeAllocatorHRS = () => {
        let total = 0;
        this.UserWeeklyLogItems.forEach(_ => {
            if (!_.UserWeeklyLog.isDeleted) {
                total += _.UserWeeklyLog.hoursLogged
            }
        })

        if(this.NonCommunityWork?.hoursLogged)
            total += this.NonCommunityWork.hoursLogged;

        return (Math.floor(total * 100) / 100).toFixed(1);
    }

    changeNonCommunityTimeAllocatorHRS = (str: string = "") => {
        const reg = /^[+-]?\d+(\.\d+)?$/;
        if (reg.test(str) || str === '') {
            const newNumber = parseFloat(str == "" ? "0" : parseFloat(str).toFixed(1));
            this.NonCommunityWork = {... this.NonCommunityWork, hoursLogged : newNumber}
            this.recalculatePercentage();
        }
    }

    toFixed = (n : number, fixed: number) => ~~(Math.pow(10, fixed) * n) / Math.pow(10, fixed);
}
export default UserWeeklyLogStore;